import { useMemo, useEffect } from 'react';
import classNames from 'classnames';

import TrashiCoinLogo from '../../../../images/trashie-logo.webp';
import { Button, BUTTON_SIZE, BUTTON_TYPE } from '../../../../global/Button';
import {
  getNextButtonStyles,
} from '../../../../utils/tbbRegistration';

import './WelcomeVirtualBox.scss';

const WelcomeVirtualBox = ({
  handleOnClick,
  storeConfig,
  stepTrackerProps,
  isValidCode,
}) => {
  // Disable scroll when the component is visible
  useEffect(() => {
    // Save original style
    const originalStyle = window.getComputedStyle(document.body).overflow;
    // Disable scroll
    document.body.style.overflow = 'hidden';
    // Restore original style when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, []);

  const {
    isTrashie: isTrashieStore,
    mainLogoSrc,
    registerTbbFlow,
  } = useMemo(() => storeConfig, [storeConfig]);

  const isTrashie = useMemo(() => (
    isTrashieStore || !mainLogoSrc
  ), [isTrashieStore, mainLogoSrc]);

  const storeLogo = useMemo(
    () => {
      if (isTrashie || !isValidCode) {
        return TrashiCoinLogo;
      }
      return mainLogoSrc;
    },
    [isTrashie, mainLogoSrc, isValidCode],
  );

  return (
    <div className="VirtualBoxContainer">
      <div className="VirtualBoxBackground">
        <div className="VirtualBoxBackground__rainbow" />
      </div>
      <div className="VirtualBoxWelcome">
        <div className="VirtualBoxWelcome__content">
          <div className={classNames('VirtualBoxWelcome__logo', { 'is-trashie': isTrashie })}>
            <img
              src={storeLogo}
              alt="store logo"
              style={registerTbbFlow?.landingPageStep?.logoStyleProperties}
            />
          </div>
        </div>
        <div className="virtualbox-button-container">
          <Button
            type={BUTTON_TYPE.QUATERNARY}
            size={BUTTON_SIZE.LARGE}
            onClick={handleOnClick}
            style={getNextButtonStyles(storeConfig)}
            trackerProps={stepTrackerProps}
          >
            LET&apos;S DO THIS!
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeVirtualBox;
